<template lang="html">
  <div id="header" class="parallaxbg">
    <div class="section-overly">
      <div class="outer-text">
        <div class="middle-text">
          <div class="inner-text">
            <div class="modal-wrap login-page">
              <div class="modal-bodies">
                <div class="downtime-banner modal-body text-bold" v-if="showDownTimeWarning">
                  {{showDownTimeMessage }} <a :href="'mailto:'+showDownTimeSubMessage">{{ showDownTimeSubMessage }}</a>
                </div>
                <div class="row modal-body">
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="login-wrap" :class="[{ 'login-h-wrap': !hideManualLogin && remainingAttempts >= 1 }]">
                      <div class="login-header">
                        <span class="logo-left">
                          <img :src="getClientLogo()" class="img-responsive" alt=""/>
                        </span>
                        <span class="logo-right d-flex align-items-center" :class="getClientLogo() ? 'ml-auto' : ''">
                          <span class="mr-10">
                            <b>Powered by</b>
                          </span>
                          <img :src="Logo" class="img-responsive"  alt=""/>
                        </span>
                      </div>
                      <div v-if="showOTPForm">
                        <div class="login-form">
                          <form @submit.prevent>
                            <div v-if="remainingOtpAttempts !== null && remainingOtpAttempts > 0"
                              class="login-error text-left mb-15">
                              <div class="login-error-body mb-15">
                                <p class="d-inline-default">{{ $t('REMAINING_ATTEMPTS') }} : </p>
                                <span>{{ remainingOtpAttempts || 0 }}</span>
                              </div>
                            </div>
                            <h3 class="inputtitle">Two-factor Authentication</h3>
                            <div class="input-group">
                              <input type="number" required v-model="otpInput">
                              <label>Enter OTP</label>
                            </div>
                            <p v-if="showTimer">Time left: {{ formattedTimer }} </p>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline" v-if="!timer">
                                <div class="forgot-pswd" @click="resend">
                                  <h4>Resend OTP</h4>
                                </div>
                              </div>
                              <div v-if="!disableOtpSubmission" class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding spl_inlineblock floatright">
                                <div class="button-style">
                                  <button type="button" @click="submit" class="primary-btn login-btn">
                                    Submit
                                  </button>
                                </div>
                              </div>
                              <div v-else-if="remainingOtpAttempts <= 0" class="login-error text-left mb-15">
                                <div class="login-error-body mb-15">
                                  <span>For your security, your account has been locked due to multiple invalid OTP attempts. Please contact your Business Admin to unlock your account</span>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div :class="['login-form', { 'login-noTop-Pad': (error_normal_login || error_password) }]" v-if="viewLogin && !showOTPForm">
                        <div v-if="showPandoLogin">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 dspl_inlineblock">
                                <div class="button-style">
                                  <button type="button" @click="pandoLogin" class="primary-btn">
                                    Pando Log in
                                  </button>
                                </div>
                              </div>
                        </div>
                        <div v-else-if="!hideManualLogin">
                          <form @submit.prevent="login">
                            <div class="error" v-if="error">User not registered in Pando</div>
                            <div v-if="remainingAttempts >= 1" class="login-error text-left mb-15">
                            <span class="login-error-header" v-if="error_normal_login">{{$t('EMAIL_OR_PASSWORD_INCORRECT')}}</span>
                            <span class="login-error-header" v-if="error_password">{{$t('PASSWORD_INCORRECT')}}</span>
                            <div class="login-error-body">
                              <p class="d-inline-default">{{$t('REMAINING_ATTEMPTS')}} : </p><span>{{remainingAttempts}}</span>
                              <p><span class="fw-600">{{$t('LOGIN_WARNING')}} : </span>{{$t('AFTER')}} <span class="fw-600">{{consecutiveErrorCounter}} {{$t('CONSECUTIVE')}}</span> {{$t('UNSUCCESSFUL_LOGIN_WARNING_TEXT')}}</p>
                            </div>
                          </div>
                          <div v-if="remainingAttempts === 0" class="login-error text-left mb-15">
                            <span class="login-error-header">{{$t('ACCOUNT_HAS_BEEN_LOCKED')}}</span>
                            <p class="login-error-optional">{{$t('TOO_MANY_FAILED_ATTEMPTS_MSG')}}</p>
                          </div>
                            <div class="error" v-if="(error_normal_login || error_password) && remainingAttempts === -1">Invalid Credentials</div>
                            <div class="input-group">
                              <input type="text" v-model="email" v-on:keyup.13="login" autocomplete="off"/>
                              <label>User name:</label>
                            </div>
                            <div class="input-group">
                              <input type="password" required id="password" name="password" autocomplete="off" readonly="true" onfocus="this.removeAttribute('readonly')">
                              <label>Password:</label>
                            </div>
                            <div class="captcha-wrapper" v-if="enableCaptcha && (!validCaptcha && siteKey) && remainingAttempts !== 0">
                              <div class="captcha-vertical-center">
                                <h2 class="sub-head mt-0"> Verify Captcha </h2>
                                <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                  :loadRecaptchaScript="true" :sitekey="`${siteKey}`" />
                              </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 no-padding footer-section text-left"
                              v-if="(!enableCaptcha || (enableCaptcha && validCaptcha))">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline">
                                <div class="forgot-pswd" @click="viewForgotPassword()">
                                  <h4 style="color: #003D31 !important;">Forgot password?</h4>
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inlineblock floatright">
                                <div class="button-style">
                                  <button type="submit" class="primary-btn login-btn">
                                    Log in
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div v-if="(!enableCaptcha || (enableCaptcha && validCaptcha)) && showSSOLogin">
                          <h5 class="text-middle mt-20">
                            <span>{{ hostname }} Users, Sign in with Microsoft </span>
                          </h5>
                          <form :action='ssoFormUrl' method='get' class="sso-btn-wrapper">
                             <div>
                              <input type="image" :src="SignInImg" class="img-responsive mt-10 sign-img" alt="Submit">
                            </div>
                          </form>
                        </div>
                      </div>
                      <div class="login-form reset" v-else-if="resetPasswordResponse && !showOTPForm">
                        <h3 class="inputtitle text-md">CHECK EMAIL FOR TEMPORARY PASSWORD</h3>
                        <div class="login-info">
                          A message has been sent to you by email with instructions on how to reset your password.
                        </div>
                        <div class="col-lg-6
                              col-md-6
                              col-sm-6
                              col-xs-12
                              no-padding">
                          <div class="button-style f-left">
                            <button type="button" @click="viewLoginScreen" class="primary-btn login-btn">
                              LOGIN
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="login-form" v-else-if="!showOTPForm">
                        <form>
                          <h3 class="inputtitle">FORGOT PASSWORD</h3>
                          <div class="input-group">
                            <input type="text" required v-model="email" v-on:keyup.13="resetPassword">
                            <label>Enter registered email address:</label>
                          </div>
                          <div class="col-lg-12
                              col-md-12
                              col-sm-12
                              col-xs-12
                              no-padding
                              footer-section">
                            <div class="col-lg-6
                                col-md-6
                                col-sm-6
                                col-xs-12
                                no-padding
                                dspl_inline">
                              <div class="forgot-pswd" @click="viewLoginScreen()">
                                <h4 style="color: #003D31 !important;">Back to login</h4>
                              </div>
                            </div>
                            <div class="col-lg-6
                                col-md-6
                                col-sm-6
                                col-xs-12
                                no-padding
                                dspl_inlineblock
                                floatright">
                              <div class="button-style">
                                <button type="button" @click="resetPassword" class="primary-btn login-btn">
                                  Reset password
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="login-disclaimer">
                        {{ $t('PANDO_PRIVACY_POLICY') }}
                        <h4 class="mb-0" @click="viewPrivacyPolicy()">Privacy Policy</h4>
                      </div>


                      <!-- <div class="login-footer">
                          <div class="row no-margin">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding text-left">
                                  Privacy Policy
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding text-right">
                                  Customer Support
                              </div>
                          </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="radius-right">
                      <img src="@common/asset/images/Sign_In.jpg" class="img-responsive full-height" alt="" style="border-radius:0 14px 14px 0px;height: 100%;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Login from '@/components/mixins/Login';
import Logo from '@common/asset/images/logo.svg';
import GenericLogo from '@common/asset/images/generic_logo.svg';
import SignInImg from '@common/asset/images/ms-symbollockup_signin_dark.svg';
import { required, email } from 'vuelidate/lib/validators';
import { isNil, capitalize } from 'lodash';
import VueRecaptcha from 'vue-recaptcha';
import { shouldPreserveRedirect } from '@/utils/redirect';

window.redirectToNewPage = () => {
  window.oauthWindow.close();
  window.location.replace('/indents');
};
const CryptoJS = require('crypto-js');

export default {
  mixins: [Login],
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      email: null,
      password: null,
      Logo,
      GenericLogo,
      SignInImg,
      // Bg,
      error: false,
      error_normal_login: false,
      error_password: false,
      viewLogin: true,
      resetPasswordResponse: null,
      form_url: null,
      remainingAttempts: -1,
      consecutiveErrorCounter: 0,
      attempts: 0,
      validCaptcha: false,
      showTimer: false,
      timer: 0,
      showOTPForm: false,
      otpInput: '',
      remainingOtpAttempts: null,
      disableOtpSubmission: false,
    };
  },
  validations: {
    email: {
      required, email,
    },
  },
  created() {
    const key = `${window.location.host}-attempts`;
    this.attempts = JSON.parse(localStorage.getItem(key)) || 0;
    const hostname = window.location.host;
    const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
    this.form_url = isDevelopment ? 'http://localhost:3000/api/login/sso/azure' : '/api/login/sso/azure';
  },
  computed: {
    ...mapGetters({
      ssoCheck: 'app/ssoCheck',
      environmentVariables: 'app/environmentVariables',
      logoInfo: 'app/getLogo',
    }),
    // Add redirect_url query param to SSO form if available
    ssoFormUrl() {
      const redirectUrl = this.$route.query.redirect_url;
      if (redirectUrl && shouldPreserveRedirect(redirectUrl)) {
        return `${this.form_url}?redirect_url=${encodeURIComponent(redirectUrl)}`;
      }
      return this.form_url;
    },
    showDownTimeWarning() {
      const isEnabled = (this.environmentVariables.is_warning_message === 'true' || this.environmentVariables.is_warning_message === true) || false;
      return !['pgsa.pando.in', 'development23.pandostaging.in'].includes(window.location.hostname) && isEnabled;
    },
    showDownTimeMessage() {
      return (this.environmentVariables && this.environmentVariables.show_message) || '';
    },
    showDownTimeSubMessage() {
      return (this.environmentVariables && this.environmentVariables.mail_to) || '';
    },
    hideManualLogin() {
      return this.ssoCheck && this.ssoCheck.hideManualLogin;
    },
    showPandoLogin() {
      return this.ssoCheck && this.ssoCheck.showPandoLogin;
    },
    showSSOLogin() {
      return this.ssoCheck && this.ssoCheck.ssoConfigurationEnabled;
    },
    hostname() {
      let hostname = '';
      if (window.location.hostname) {
        hostname = window.location.hostname;
      }
      hostname = capitalize(hostname.split('.')[0]);
      return hostname;
    },
    enableCaptcha() {
      return (this.environmentVariables.rc_enabled === 'true' || this.environmentVariables.rc_enabled === true) && this.attempts >= 3;
    },
    siteKey() {
      return this.environmentVariables.rc_site_key;
    },
    formattedTimer() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    ssoProvider() {
      const provider = (this.ssoCheck && this.ssoCheck.provider) || 'SSO';
      return provider.charAt(0).toUpperCase() + provider.slice(1);
    },
  },
  methods: {
    pandoLogin() {
      window.oauthWindow = window.open('/login?pandoLogin=true', 'Pando Login', 'width=800,height=600');
    },
    getClientLogo() {
      return this.logoInfo ? this.logoInfo
        : GenericLogo;
    },
    updateLoginAttempts(key) {
      const storedAttempts = JSON.parse(localStorage.getItem(key));
      this.validCaptcha = false;
      if (storedAttempts) {
        localStorage.setItem(key, (parseInt(storedAttempts, 10) + 1).toString());
        this.attempts = (parseInt(storedAttempts, 10) + 1);
      } else {
        localStorage.setItem(key, 1);
        this.attempts = 1;
      }
    },
    startTimer() {
      if (this.timer > 0) {
        this.timerTimeout = setTimeout(() => {
          this.timer -= 1;
          this.startTimer();
        }, 1000);
      } else {
        this.timerId = setTimeout(() => {
          this.showTimer = false;
          this.showOTPForm = false;
          this.otpInput = '';
          localStorage.setItem('tsm-user-token', '');
        }, 30000);
      }
    },
    async submit() {
      const optAuth = localStorage.getItem('otp-auth-token');
      const data = { otp: this.otpInput, secretKey: optAuth };
      const result = await this.$store.dispatch('app/verifyToken', {
        data,
      });
      localStorage.setItem('otp-verified', false);
      if (result.status === 204) {
        const key = `${window.location.host}-attempts`;
        localStorage.setItem('otp-verified', true);
        localStorage.setItem(key, JSON.stringify(0));
        clearInterval(this.timerTimeout);
        if (this.$route.query.pandoLogin) {
          window.opener.redirectToNewPage();
        }
        const bootstrapData = await this.$store.dispatch('app/bootstrap');
        await this.validateRedirect(bootstrapData);
      } else if (result.data && result.data.remainingAttempts > 0) {
        this.remainingOtpAttempts = result.data.remainingAttempts;
        this.$errorMessage({ message: 'Invalid OTP' });
      } else if (result.data && result.data.remainingAttempts <= 0) {
        this.$errorMessage({ message: 'Invalid OTP' });
        this.remainingOtpAttempts = result.data.remainingAttempts;
        this.disableOtpSubmission = true;
      } else {
        this.$errorMessage({ message: 'Invalid OTP' });
      }
    },
    async resend() {
      localStorage.setItem('otp-auth-token', '');
      const data = { email: this.email };
      const result = await this.$store.dispatch('app/generateToken', {
        data,
      });
      if (result.otpAuthToken) {
        clearTimeout(this.timerId);
        this.showTimer = true;
        this.timer = result.otp_timer || 0;
        this.showOTPForm = true;
        localStorage.setItem('otp-auth-token', result.otpAuthToken);
        this.startTimer();
      }
    },
    async login() {
      this.$v.email.$touch();
      if (!this.$v.email.$error) {
        try {
          const appConfidentialKey = window.location.origin.replace(/\/|http:|https:/gi, () => '');
          const encryptedPassword = CryptoJS.AES.encrypt(JSON.stringify(document.getElementById('password').value), appConfidentialKey).toString();
          const encryptedEmail = CryptoJS.AES.encrypt(JSON.stringify(this.email), appConfidentialKey).toString();
          const payload = { email: encryptedEmail, password: encryptedPassword };
          const encryptedPayload = CryptoJS.AES.encrypt(JSON.stringify(payload), `${appConfidentialKey}/pandoV3`).toString();

          const result = await this.$store.dispatch('app/loginV3', { data: encryptedPayload });
          const key = `${window.location.host}-attempts`;
          if (result && result.otpAuthToken) {
            this.attempts = 0;
            this.showTimer = true;
            this.timer = result.otp_timer || 0;
            localStorage.setItem(key, JSON.stringify(0));
            this.showOTPForm = true;
            localStorage.setItem('otp-verified', false);
            localStorage.setItem('otp-auth-token', result.otpAuthToken);
            this.startTimer();
          }
          if (result) {
            if (result.status === 204 && result.headers && result.headers['x-auth-token']) {
              this.attempts = 0;
              if (this.$route.query.pandoLogin) {
                window.opener.redirectToNewPage();
              }
              localStorage.setItem(key, JSON.stringify(0));
              const bootstrapData = await this.$store.dispatch('app/bootstrap');
              this.setFreshWidget(bootstrapData);
              this.validateRedirect(bootstrapData);
            } else if (result.status === 404) {
              this.updateLoginAttempts(key);
              this.error_password = false;
              this.error_normal_login = true;
              this.remainingAttempts = (result.data && result.data.remainingAttempts) || -1;
              if (!this.consecutiveErrorCounter) {
                this.consecutiveErrorCounter = this.remainingAttempts;
              } else {
                this.consecutiveErrorCounter -= 1;
              }
            } else if (result.status === 401) {
              this.updateLoginAttempts(key);
              this.error_normal_login = false;
              this.error_password = true;
            } else if (result.status === 400) {
              if (result.data && result.data.errors && result.data.errors[0]) {
                if (result.data.errors[0].code === 'ERR_LOGIN_INACTIVATED') {
                  this.$errorMessage({ message: result.data.errors[0].message });
                }
              }
            }
            if (result.data && result.data.errors && result.data.errors[0]) {
              if (result.data.errors[0].code === 'ERR_MAX_LOGIN_ATTEMPTS') {
                this.remainingAttempts = 0;
              }
            }
          }
        } catch (err) {
          throw err;
        }
      } else {
        this.error_normal_login = true;
        this.error_password = false;
      }
      return true;
    },
    async resetPassword() {
      try {
        const data = { email: this.email };
        const result = await this.$store.dispatch('app/forgotPassword', {
          data,
        });
        if (result.status === 204) {
          this.resetPasswordResponse = true;
        } else if (result.status === 404) {
          this.$errorMessage({
            message: 'No account is found with the given email address',
          });
        } else if (result && result.data && result.data.errors) {
          this.$errorMessage({ message: result.data.errors[0].message });
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    viewLoginScreen() {
      this.viewLogin = true;
      this.resetPasswordResponse = null;
    },
    viewForgotPassword() {
      this.viewLogin = false;
      this.resetPasswordResponse = null;
    },
    async onCaptchaVerified(recaptchaToken) {
      try {
        const response = await this.$store.dispatch('app/reCaptchaVerify', recaptchaToken);
        if (response && response.data && response.data.success) {
          this.validCaptcha = true;
        } else {
          this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
        }
      } catch (error) {
        throw error;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    updateLoginAttempts(key) {
      const storedAttempts = localStorage.getItem(key);
      this.validCaptcha = false;
      if (storedAttempts) {
        localStorage.setItem(key, (parseInt(storedAttempts, 10) + 1).toString());
        this.attempts = (parseInt(storedAttempts, 10) + 1);
      } else {
        localStorage.setItem(key, 1);
        this.attempts = 1;
      }
    },
    viewPrivacyPolicy() {
      window.open('https://pando.ai/privacy.php', '_blank');
    },
  },
  async mounted() {
    try {
      this.error = false;
      const urlParams = new URLSearchParams(document.location.search.substring(1));
      const token = urlParams.get('pat');
      const userNotFound = urlParams.get('user_not_found');
      if (!isNil(userNotFound)) {
        this.error = true;
      }
      if (!isNil(token)) {
        localStorage.setItem('tsm-user-token', token);
        const result = await this.$store.dispatch('app/bootstrap');
        if (result && result.current_user && this.environmentVariables.rtly_site_key) {
          const vueContainer = document.getElementById('retently-survey-embed');
          if (vueContainer) {
            vueContainer.setAttribute(
              'data-href',
              `https://app.retently.com/api/remote/tracking/${this.environmentVariables.rtly_site_key}`,
            );
            vueContainer.setAttribute('data-rel', 'dialog');
            vueContainer.setAttribute('data-campaign', 'regular');
            vueContainer.setAttribute('data-email', result.current_user.email || '-');
            vueContainer.setAttribute('data-firstname', result.current_user.name || '-');
            vueContainer.setAttribute('data-lastname', '-');
            vueContainer.setAttribute('data-company', result.client.name || '-');
            vueContainer.setAttribute('data-tags', 'inapp');
            const script = document.createElement('script');
            script.innerHTML = (function (d, s, id) {
              let js,
                rjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s);
              js.id = id;
              js.src =
                'https://cdn.retently.com/public/components/embed/sdk.min.js';
              rjs.parentNode.insertBefore(js, rjs);
            }(document, 'script', 'retently-jssdk'));
            document.head.appendChild(script);
          }
        }
        this.validateRedirect(result);
      }
      return true;
    } catch (err) {
      return err;
    }
  },
};
</script>

<style lang="scss">
$fontSemibold: "OpenSans-Semibold";
$fontBold: "OpenSans-Bold";

#header {
  width: 100%;
  padding: 0;
  float: left;
  height: 100vh;
}

.parallaxbg {
  background-image: url(~@common/asset/images/login_bg.jpg);
  // margin: -120px -20px -20px -20px !important;
  width: 100%;
  margin: 0 auto;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  overflow: hidden;
}

.section-overly {
  min-height: 100vh;

  .no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .dspl_inline {
    display: inline;
  }

  .dspl_inlineblock {
    display: inline-block;
  }

  .inputtitle {
    width: 100%;
    margin-bottom: 25px;
    font-family: $fontSemibold;
    font-size: 1.4rem;
    color: #005399;
    text-align: left;

    &.text-md {
      font-size: 1.3rem !important;
    }
  }

  .login-info {
    margin-bottom: 20px;
    font-size: 1.2rem;
    line-height: 20px;
    color: #5a6277;
    text-align: left;
  }

  .outer-text {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }

  .middle-text {
    display: table;
    width: 100%;
    height: 100%;
  }

  .inner-text {
    display: table-cell;
    vertical-align: middle;
  }

  form {
    input {
      width: 100%;
      border: 0;
      border-bottom: 1px solid #9b9b9c;
      padding: 12px 0 9px;
      font-family: $fontSemibold;
      font-size: 12px;
      color: #404040;
      height: 34px;

      &:focus {
        outline: none;
        border-bottom: 1px solid #003F91;
      }

      &.sign-img {
        height: auto;
        border-bottom: 1px solid transparent;

      }
    }

    .input-group {
      position: relative;
      width: 100%;
      margin: 10px 0 20px;

      label {
        content: attr(data-placeholder);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-transform: translate(0%, -50%);
        transform: translate(0%, -50%);
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        background-color: rgba(255, 255, 255, 0);
        color: #404040;
        font-size: 10px;
        font-weight: normal;
        line-height: 10px;
        text-transform: uppercase;

        input[type="text"],
        input[type="password"] {
          border-bottom: 1px solid #9999a3;
        }

        input[type="text"]:focus,
        input[type="text"]:valid,
        input[type="password"]:focus,
        input[type="password"]:valid {
          border-bottom: 1px solid #9b9b9c;
        }

        input:focus~label,
        input:valid~label {
          top: -1px;
          color: #404040;
          font-size: 10px;
          font-weight: normal;
          line-height: 10px;
          text-transform: uppercase;
        }
      }
    }
  }

  .modal-wrap {
    max-width: 1000px !important;
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 3px 3px 10px 0 #01314f;
    -webkit-transition: -webkit-transform 300ms ease-in-out;
    transition: -webkit-transform 300ms ease-in-out;
    transition: transform 300ms ease-in-out;
    transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;

    .modal-bodies {
      position: relative;
      -webkit-perspective: 1000px;
      perspective: 1000px;
    }

    .modal-body {
      margin: 0;
    }
  }

  .login-page form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .login-wrap {
    box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 4px 0px 0px 4px !important;
    height: 528px;

    .login-header {
      padding: 30px 20px 20px 30px;
      text-align: left;
    }

    .login-form {
      padding: 45px 50px;

      &.reset {
        padding-right: 15px;
      }
    }

    .login-noTop-Pad {
      padding-top: 10px;
    }

    .border-line {
      border: 2px solid #008aff;
      float: left;
      width: 47px;
      margin: 0 30px;
    }
  }

  .login-h-wrap{
    height: 600px;
  }

  .footer-section {
    margin: 10px 0;

    .forgot-pswd h4 {
      float: left;
      margin: 0;
      color: #008aff;
      font-size: 1rem;
      line-height: 26px;
      cursor: pointer;
    }
  }

  .button-style {
    text-align: right;

    .primary-btn {
      cursor: pointer;
      background-color: #008aff;
      color: #fff;
      border: 1px solid #008aff;
      border-radius: 2px;
      padding: 7px 10px;
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: normal;
      white-space: nowrap;
      outline: none;
    }
  }

  .conditions {
    padding: 0 50px 30px;
    vertical-align: bottom;
    position: relative;

    h5 {
      color: #008aff;
      font-family: $fontSemibold;
      font-size: 10px;
      text-align: left;
    }

    p {
      color: #929292;
      font-size: 9px;
      letter-spacing: 0.23px;
      text-align: left;
    }
  }

  .error {
    display: block;
    color: #e8655d;
    font-size: 15px;
    margin: 10px;
  }
}

.msglength {
  margin-top: 10px;

  &-text {
    font-size: 10px;
    color: #5a6277;
    float: left;
  }

  &-character {
    font-size: 10px;
    color: #5a6277;
    float: right;
  }
}

.radius-right {
  line-height: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 100%;
}

.login-btn {
  background-color: #077D8A !important;
  border: 1px solid #077D8A !important;
  border-radius: 4px !important;
}

.msg-content {
  color: #5a6277;
  font-size: 12px;
  text-align: left;
  line-height: 18px;
}

.floatleft {
  float: left !important;
}

.floatright {
  float: right !important;
}

.msgerror {
  color: #d12424;
}

.button-style button:disabled {
  opacity: 0.2;
}

.mt-40 {
  margin-top: 40px;
}
.captcha-wrapper {
    height: 100%;
    position: fixed;
    top: 15%;
    transform: translateX(-50%);
    .captcha-vertical-center {
      width: 345px;
      padding: 20px;
      margin-left: -172px;
      position: absolute;
      top: 48%;
      left: 0;
      border-radius: 4px;
      box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.06);
      transform: translateY(-48%);
    }
  }

  .sso-btn-wrapper {
  display: flex;
  justify-content: center;
}

.sso-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border: none;
  background: #323232;
  color: #fff;
  cursor: pointer;
  max-width: 320px;
  font-size: 14px;
  font-weight: 500;
  transition: 0.2s ease;
}

.sso-btn:hover {
  opacity: 0.85;
}

.sso-text {
  font-size: 14px;
  font-weight: 600;
}

</style>
